export { default as HomeAnimation } from "./homeAnimation.json";
export { default as LogoAnimation } from "./logoAnimation.json";
export { default as LoadingPages } from "./loadingPages.json";